jQuery(document).ready(function () {
    (function ($) {
        $(document).on("click", '#navbarsec', function (e) {
            $("#navbarsec .accordion-item .accordion-title .icon-minus")
                .removeClass("icon-minus")
                .addClass("icon-plus");

            $("#navbarsec .accordion-item.is-active .icon-plus")
                .removeClass("icon-plus")
                .addClass("icon-minus");
        });

        $(document).on("down.zf.accordion", '#navbarsec', function () {
            var top = $(this).find(".accordion-item.is-active").offset().top;
            $("html, body").animate({
                scrollTop: top
            }, 300);
        });

    }(jQuery));
});
